interface EmptyStateProps {
  title: string
  description: string
}

export function EmptyState({ title, description }: EmptyStateProps) {
  return (
    <div className="mt-8 w-full rounded-2xl border border-dashed border-gray-300 bg-white px-6 py-10 text-center">
      <p className="text-base font-semibold text-gray-700">{title}</p>
      <p className="mt-2 text-sm text-gray-500">{description}</p>
    </div>
  )
}
